import { render, staticRenderFns } from "./enCourseDetail.vue?vue&type=template&id=f5a675b0&scoped=true&"
import script from "./enCourseDetail.vue?vue&type=script&lang=js&"
export * from "./enCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./enCourseDetail.vue?vue&type=style&index=0&id=f5a675b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5a675b0",
  null
  
)

export default component.exports